import { makeStyles } from "@material-ui/core";
import { RoundedImageChooserProps, SizeTypes } from "./RoundedImageChooser";

const chooserSize = (size: SizeTypes): any => {
  switch (size) {
    case "medium":
      return {
        width: 100,
        height: 100,
      };
    case "large":
      return {
        width: 140,
        height: 140,
      };
  }

  return {
    width: 100,
    height: 100,
  };
};

const fabSize = (size: SizeTypes): number => {
  switch (size) {
    case "medium":
      return 30;
    case "large":
      return 40;
  }

  return 30;
};

export const useStyles = makeStyles(
  (theme) => ({
    input: {
      display: "none",
    },

    roundedWrapper: (props: RoundedImageChooserProps) => ({
      position: "relative",
      width: `${chooserSize(props.size).width + "px"}`,
      height: `${chooserSize(props.size).height + "px"}`,

      "& .content": {
        padding: 2,
        borderRadius: "100%",

        "& img": {
          verticalAlign: "middle",
          width: `${chooserSize(props.size).width - 10 + "px"}`,
          height: `${chooserSize(props.size).height - 10 + "px"}`,
          borderRadius: "100%",
        },
      },

      "& .floatChooser": {
        width: `${fabSize(props.size) + "px"}`,
        height: `${fabSize(props.size) + "px"}`,
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "100%",

        position: "absolute",
        bottom: 4,
        right: 6,
        cursor: "pointer",

        "&:hover": {
          opacity: 0.8,
        },
      },
    }),
  }),
  { name: "rounded-image-chooser-style", flip: null }
);
